<template>
    <div>
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="text-operations"></div>
  
      <!-- Header -->
      <div class="form-section" style="box-shadow:none; background:transparent; padding:12px 10px;">
        <h3 style="display:inline-flex; align-items:center; gap:8px; margin:0;">
          Generación de papeleta
          <img src="@/assets/filtros.png" style="width:22px; height:22px;" />
        </h3>
      </div>
  
      <!-- Compact Filters Card + Enter to submit -->
      <form class="filters-card" @submit.prevent="generateReport">
        <!-- Fechas -->
        <div class="row">
          <label>Fecha</label>
          <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Cliente con sugerencias -->
        <div class="row row-rel">
          <label for="client_name">Cliente</label>
          <input
            id="client_name"
            type="text"
            v-model="clientName"
            placeholder="Ingrese el cliente a buscar"
            @input="filterClients"
            autocomplete="off"
          />
          <div class="cell span-2"></div>
  
          <!-- Suggestions List -->
          <ul v-if="filteredClients.length" class="suggestions-list">
            <li v-for="(client, index) in filteredClients" :key="index" @click="selectClient(client)">
              {{ client.client_ident + ' - ' + client.client_name }}
            </li>
          </ul>
        </div>
  
        <!-- Número de orden (rango) -->
        <div class="row">
          <label for="note_number_start">Número de orden</label>
          <input id="note_number_start" type="text" v-model="noteNumberStart" placeholder="Inicio" autocomplete="off" />
          <span class="sep">al</span>
          <input id="note_number_end" type="text" v-model="noteNumberEnd" placeholder="Fin" autocomplete="off" />
        </div>
  
        <!-- Sucursal -->
        <div class="row">
          <label for="sucursal">Sucursal</label>
          <select id="sucursal" v-model="sucursal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <!-- Operador -->
        <div class="row">
          <label for="operator_id">Operador</label>
          <input id="operator_id" type="text" v-model="operatorId" placeholder="ID del operador" autocomplete="off" />
          <div class="cell span-2"></div>
        </div>
  
        <!-- Unidad -->
        <div class="row">
          <label for="unit_id">Unidad</label>
          <input id="unit_id" type="text" v-model="unitId" placeholder="ID de unidad" autocomplete="off" />
          <div class="cell span-2"></div>
        </div>
  
        <!-- Expediente -->
        <div class="row">
          <label for="unit_id">Expediente</label>
          <input id="unit_id" type="text" v-model="fileNumber" placeholder="Expediente" autocomplete="off" />
          <div class="cell span-2"></div>
        </div>

        <!-- Tipo de servicio -->
        <div class="row">
          <label for="type">Tipo de servicio</label>
          <select id="type" v-model="type" class="form-select">
            <option value="" disabled selected>Seleccione un tipo de servicio</option>
            <option value="Asistencia víal">Remolque</option>
            <option value="Auxilio víal">Auxilio vial</option>
            <option value="Lote">Lote</option>
            <option value="Montacargas">Montacargas</option>
            <option value="Industrial">Industrial</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <!-- Submit -->
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-primary" :disabled="isGeneratingReport">
              {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <style scoped>
  /* existing styles kept as-is ... */
  
  /* === Compact Filters Card (adds Enter-to-submit UX) === */
  :root{
    --brand:#FFC434; --brand-600:#e6b12e;
    --card:#fff; --bg:#f7f7f8; --border:#e8e8ea; --text:#1f2328; --muted:#70737a;
    --radius:8px; --shadow:0 1px 6px rgba(0,0,0,.06);
  }
  
  .filters-card{
    margin:10px; background:var(--card); border:1px solid var(--border); border-radius:var(--radius);
    box-shadow:var(--shadow); padding:8px; display:grid; grid-template-columns:1fr; gap:6px; font-size:12px;
  }
  .filters-card .row{
    display:grid; grid-template-columns:140px 320px 22px 320px;
    gap:4px; align-items:center; min-height:28px; margin-bottom:2px;
  }
  .filters-card .row.actions{ grid-template-columns:1fr; }
  .filters-card .row.row-rel{ position:relative; }
  
  .filters-card label{ color:var(--text); white-space:nowrap; }
  .filters-card .sep{ text-align:center; color:var(--muted); font-size:11px; }
  
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select{
    height:26px; padding:0 8px; border:1px solid #d2d2d2; border-radius:6px;
    background:#fff; font-size:12px; outline:none;
  }
  .filters-card input:focus, .filters-card select:focus{
    border-color:#bfbfbf; box-shadow:0 0 0 2px rgba(255,196,52,.22);
  }
  .grayed-out{ background:#f2f2f2; color:#999; }
  
  .filters-card .cell{ height:0; }
  .filters-card .span-2{ grid-column:4/4; }
  .filters-card .span-4{ grid-column:1/-1; }
  
  .btn-primary{
    padding:6px 12px; font-size:12px; border-radius:8px; background:var(--brand);
    border:none; cursor:pointer; box-shadow:var(--shadow);
  }
  .btn-primary:hover{ background:var(--brand-600); }
  
  /* Suggestions dropdown aligned to the first control column */
  .suggestions-list{
    position:absolute; top:30px; left:140px; width:320px; max-height:200px;
    overflow-y:auto; background:#fff; border:1px solid #ccc; border-radius:6px;
    box-shadow:0 4px 6px rgba(0,0,0,.1); z-index:1000; margin:0; padding:0; list-style:none; font-size:12px;
  }
  .suggestions-list li{ padding:8px 10px; cursor:pointer; }
  .suggestions-list li:hover{ background:#f0f8ff; font-weight:600; }
  
  /* Responsive */
  @media (max-width:1200px){
    .filters-card .row{
      grid-template-columns:120px minmax(180px,1fr) 18px minmax(180px,1fr);
    }
  }
  @media (max-width:860px){
    .filters-card .row{ grid-template-columns:120px 1fr; }
    .filters-card .sep, .filters-card .row>.cell{ display:none; }
    .suggestions-list{ left:0; width:100%; }
  }

  /* replace this */
.filters-card .span-2{ grid-column:4/4; }
/* with this */
.filters-card .span-2{ grid-column: 3 / -1; }  /* span the last two columns */

  </style>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading';
  import Fuse from 'fuse.js';
  
  export default {
    data() {
      return {
        startDate: '',
        endDate: '',
        clientName: '',
        noteNumberStart: '',
        noteNumberEnd: '',
        sucursal: '',
        operatorId: '',
        unitId: '',
        fileNumber: '',
        type: '',
        clientIdent: '',
        clients: [],
        filteredClients: [],
        fuse: '',
        highlightedIndex: -1,   // added to avoid undefined usage
        blockEdit: false,
        isGeneratingReport: false,
      };
    },
  
    computed: {
      effectiveEndDate() {
        return this.endDate || this.startDate;
      },
    },
  
    methods: {
      async fetchClients() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
          this.clients = response.data;
          this.initializeFuse();
        } catch (error) {
          console.error('Error fetching clients:', error);
        }
      },
      initializeFuse() {
        const options = {
          keys: ['client_name'],
          threshold: 0.3,
          ignoreLocation: true,
          includeScore: false,
        };
        this.fuse = new Fuse(this.clients, options);
      },
      filterClients() {
        const searchTerm = (this.clientName || '').toLowerCase().trim();
        if (!searchTerm) { this.filteredClients = []; this.highlightedIndex = -1; return; }
        this.filteredClients = this.clients.filter(c =>
          (c.client_name || '').toLowerCase().includes(searchTerm) ||
          (c.client_ident || '').toLowerCase().includes(searchTerm)
        );
        this.highlightedIndex = -1;
      },
      selectClient(client) {
        this.clientName = client.client_name;
        this.clientIdent = client.client_ident;
        this.filteredClients = [];
      },
      formatToDatetime(date, time) {
        if (!date) return '';
        return `${date}T${time}`;
      },
      backMainPanel() {
        window.location.href = '/main-panel';
      },
      validateNoteNumbers() {
        if (this.noteNumberStart !== '' && this.noteNumberEnd === '') {
          Swal.fire({ icon: 'error', title: 'Error de validación', text: 'Debe ingresar un número de orden final cuando ingresa un número inicial' });
          return false;
        }
        if (this.noteNumberStart === '' && this.noteNumberEnd !== '') {
          Swal.fire({ icon: 'error', title: 'Error de validación', text: 'No puede ingresar un número de orden final sin un número inicial' });
          return false;
        }
        if (this.noteNumberStart !== '' && this.noteNumberEnd !== '') {
          const startNum = parseInt(this.noteNumberStart);
          const endNum = parseInt(this.noteNumberEnd);
          if (endNum < startNum) {
            Swal.fire({ icon: 'error', title: 'Error de validación', text: 'El número de orden final debe ser mayor o igual al número de orden inicial' });
            return false;
          }
        }
        return true;
      },
      async generateReport() {
        if (this.isGeneratingReport) return;
        if (!this.validateNoteNumbers()) return;
  
        const payload = {
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          client_name: this.clientName || "",
          note_number_start: this.noteNumberStart,
          note_number_end: this.noteNumberEnd,
          sucursal: this.sucursal,
          operator_id: this.operatorId,
          unit_id: this.unitId,
          file_number: this.fileNumber,
          type: this.type,
          client_ident: this.clientName === "" ? "" : this.clientIdent,
        };
  
        this.isGeneratingReport = true;
        showReportLoading();

        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/reports/assistance/`, payload, {
            responseType: 'blob',
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'papeleta.zip');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          const errorMessage = error.response ? error.response.data.error : error.message;
          Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
        } finally {
          this.isGeneratingReport = false;
          hideReportLoading();
        }
      },
    },
  
    mounted() {
      this.fetchClients();
    }
  };
  </script>
  